export default __webpack_public_path__ + "static/RootSans-8SemiBoldItalic-835dd5a22e8e44c68e2b1618876196b6.woff2";